import { Col, Container, Row } from '@paypalcorp/pp-react'
import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import HamburgerIcon from '../HamburgerSVG'
import LoginButton from '../LoginButton/LoginButton'
import NavigationButtons from '../NavigationButtons/NavigationButtons'
import AiSearch from '../AiSearch'
import PaypalDeveloperSVG from '../PayPalDeveloperSVG'
import './navbar.css'
import { useApplicationContext } from '../../../../provider'

interface NavbarProps {
  user: any // TODO: define a new interface with all the values expected from the user and add use interface like UserProps
  location: Location
  inverseHeaderScheme: boolean
}

export const Navbar: React.FC<NavbarProps> = ({
  user,
  location,
  inverseHeaderScheme,
}) => {
  const { experiments } = useApplicationContext()
  const [launcher, setLauncher] = useState<any>(null)
  const [loginURL, setLoginURL] = useState('')
  const [logoutURL, setLogoutURL] = useState('')
  const userLoggedOut = !user?.loggedIn
  const [searchID, setSearchID] = useState('')

  const alternateColorFun = (() => {
    if (inverseHeaderScheme) return 'header-web-home'
    return 'header-web-not-home'
  })()

  useEffect(() => {
    if (!isEmpty(user)) {
      setLoginURL(
        user.login.url.replace(
          /PAGEURL/g,
          encodeURIComponent((location && location.href) || '#'),
        ),
      )
      setLogoutURL(
        user.logout.url.replace(
          /PAGEURL/g,
          encodeURIComponent((location && location.href) || '#'),
        ),
      )
    }
  }, [location, user])

  useEffect(() => {
    setLauncher(
      typeof window !== `undefined`
        ? require('@paypalcorp/dx-ui-react/')
        : null,
    )
  }, [])

  return (
    <Container
      fluid={true}
      className={
        !userLoggedOut
          ? `header-web ${alternateColorFun} header-web-loggedIn`
          : `header-web ${alternateColorFun}`
      }
    >
      <Row>
        <Col xs={4} lg={4} className="nav-col_overlap">
          <div className="firstCol-wrapper">
            <HamburgerIcon />
            <a href="/">
              <PaypalDeveloperSVG />
            </a>
            {experiments.aiSearch === 'Trmt_Developer_AI_Search' ? (
              <AiSearch setSearchID={setSearchID} searchID={searchID} />
            ) : (
              <span className={`algoliaSearchlaunch Web ${'search-input'}`}>
                {launcher && <launcher.SearchModal />}
              </span>
            )}
          </div>
        </Col>
        {/* <Col md={1} className="spacer-col" /> */}
        <Col xs={6} lg={6} className="nav-col">
          {/* TODO: this props does not exist on this component - user={user} loginURL={loginURL}  */}
          <NavigationButtons />
        </Col>
        {userLoggedOut ? (
          <Col xs={2} lg={2} className="nav-col">
            <div className="loginButtonWrapper">
              <LoginButton
                user={user}
                loginURL={loginURL}
                searchID={searchID}
              />
            </div>
          </Col>
        ) : null}
      </Row>
    </Container>
  )
}
